module.exports = __webpack_public_path__ + "img/bell_4.90e75ac7.jpg";